import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/global.css";
import { BrowserRouter } from "react-router-dom";
import { GlobalProvider } from "../src/context/GlobalContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
    <BrowserRouter>
      <GlobalProvider>  {/* <-- Wrap your app with the provider */}
        <App />
      </GlobalProvider>
    </BrowserRouter>
  // </React.StrictMode>
);
